<div id="newLogoContent" class="tab-pane active">
  <form [formGroup]="logoContentgrpForm">
    <div id="logoContentRow" class="row">
      <div id="logoContentCol" class="col-lg-3">
      <div id="logoContentFormGrp" class="form-group">
        <label for="publishedName"><span i18n="@@global.tab-text.published-name">Published Name</span><span class="text-danger">*</span></label>
        <input type="text" class="form-control" id="publishedName" placeholder={{publishedNamePlaceholderText}}
          formControlName="publishedName" name="publishedName" maxlength="50" required />
        <div id="logoContentSubmittedName" *ngIf="isSubmitted && logoContentgrpForm?.controls?.publishedName?.value.trim() === ''"
          class="formfield_err_msg"><span i18n="@@create-logo-content.tab-pane.required-field">This is a required field.</span></div>
        <div id="logoContentSubmittedMax" *ngIf="isSubmitted && logoContentgrpForm?.controls?.publishedName?.errors?.maxlength"
          class="formfield_err_msg"><span i18n="@@create-logo-content.tab-pane.50-characters-long">Published name may be up to 50 characters long.</span></div>
        </div>
        <div id="internalName" class="form-group">
          <label for="internalName"><span i18n="@@global.tab-text.internal-name">Internal Name</span></label>
          <input type="text" class="form-control" id="internalName" placeholder={{internalNamePlaceholderText}}
            formControlName="internalName" maxlength="50" />
          </div>
        </div>
      <div id="publishDateCustomDatepickerFormGrp" class="form-group logo_vertical_border" [ngClass]="(isPublishDateCustomDatepicker || isExpiryDatePicker) ?'col-lg-8':'col-lg-4'">
        <label for="publishedTimeStamp"><span i18n="@@create-logo-content.tab-pane.publish-date-time">Publishing Date and Time</span></label>
        <div id="publishDateSection" class="publishDate-Section">
          <div id="publishdateRadio">
            <input type="radio" name="publishdate" id="now" class="form-check-input" id="now"
              [checked]="!isPublishDateCustomDatepicker" (click)="selectCustomPublishDate('Now')" />
            <label for="now"><span i18n="@@create-logo-content.tab-pane.now">Now</span></label>
          </div>
          <div id="customDatePicker" class="custom-datepicker">
            <input type="radio" name="publishdate" id="publish-date-custom" class="form-check-input"
              id="publish-date-custom" [checked]="isPublishDateCustomDatepicker"
              (click)="selectCustomPublishDate('custom')" />
            <label for="publish-date-custom" *ngIf="!isPublishDateCustomDatepicker"><span i18n="@@create-logo-content.tab-pane.custom">Custom</span></label>
            <div id="publishDateCustomDatepickerErr" *ngIf="isPublishDateCustomDatepicker">
              <iposcen-date-time-zone (errorMessageTime)="checkIfTimeset($event,'publish')" (getDateTimeZoneData)="getLogoContentPublishDate($event)" 
              (isTimeZoneSelected)="checkTimeZone($event,'publish')" [publishDateInfo]="editPublishDateInfo">
              </iposcen-date-time-zone>
            </div>
          </div>
          <div id="customPublishDateCorrect" *ngIf="isCustomPublishDateCorrect || isCustomPublishTimeZoneSelected" class="formfield_err_msg"><span i18n="@@create-logo-content.tab-pane.publish-date-time-zone">Please select the publishing date and time zone</span> 
          </div>
        </div>
        <label for="publishedTimeStamp"><span i18n="@@create-logo-content.tab-pane.expiry-date-time">Expiration Date and Time</span></label>
        <div id="neverPublishDateSection" class="publishDate-Section">
          <div id="neverPublishDateRadio">
            <input type="radio" name="expiryDate" id="never" class="form-check-input" id="never"
              [checked]="!isExpiryDatePicker" (click)="selectExpiryDateTimeZone('Never')" />
            <label for="never"><span i18n="@@create-logo-content.tab-pane.never">Never</span></label>
          </div>
          <div id="neverCustomDatePicker" class="custom-datepicker">
            <input type="radio" name="expiryDate" id="expiry-custom" class="form-check-input" id="expiry-custom"
              [checked]="isExpiryDatePicker" (click)="selectExpiryDateTimeZone('custom')" />
            <label for="expiry-custom" *ngIf="!isExpiryDatePicker"><span i18n="@@create-logo-content.tab-pane.custom">Custom</span></label>
            <div id="neverExpiryDatePicker" *ngIf="isExpiryDatePicker">
              <iposcen-date-time-zone (errorMessageTime)="checkIfTimeset($event,'expiry')" (getDateTimeZoneData)="getLogoContentExpiryDate($event)" 
              (isTimeZoneSelected)="checkTimeZone($event,'expiry')"  [expiryDateInfo]="editexpiryDateInfo" >
              </iposcen-date-time-zone>
            </div>
          </div>
          <div id="neverExpiredDateIncorrect" *ngIf="isExpiredDateIncorrect" class="formfield_err_msg"><span i18n="@@create-logo-content.tab-pane.expiry-less-than-publish-date">Expiration date should not be before publishing date.</span>
          </div>
          <div id="neverCustomExpiryDateCorrect" *ngIf="isCustomExpiryDateCorrect || isCustomExpiryTimeZoneSelected" class="formfield_err_msg"><span i18n="@@create-logo-content.tab-pane.expiry-date-and-time-zone">Please select expiration date and time zone.</span> 
          </div>
        </div>
      </div>
      <!-- IIT2-4652 story start -->
        <div id="applyContentGrp" class="form-group col-lg-5">
          <label for=""><span i18n="@@create-promo-content.apply-content-group-to-label">Apply content group to</span></label><br/>
          <button type="button" class="btn btn-primary left_icon_btn gtmFormFactorPromo" (click)="openFormFactorsModal()">
            <img src="assets/images/laptop_icon.svg" alt="select form factors" />
            <span i18n="@@create-promo-content.select-form-factor">Select Form Factors</span>
          </button>
          <iposcen-form-factors #formFactorsModal [contentName]="selectedLogoFormFactors"
            (applyFormFactor)="applyLogoFormFactor($event)"></iposcen-form-factors>
          <div id="applyContentGrpFormFactors" *ngIf="selectedLogoFormFactors" class="selected_factors">
            <div id="applyContentGrpDevicesSection">
              <div id="applyContentGrpDevices">
                <div id="applyContentGrpDeviceTypes" class ="font-bold inline-block"><span >{{globConst.DEVICE_TYPES}}</span>: </div>
                <div id="selectedLogoFormFactorsDevice" class="inline">&nbsp;<span>{{ selectedLogoFormFactors?.devices}} </span></div>
              </div>
               <div id="applyContentGrpManucturesSection">
                <div id="applyContentGrpManuctures" class ="font-bold inline-block"><span >{{globConst.MANUFACTURERS}}</span>: </div>
                <div id="selectedLogoFormFactorsManuctures" class="inline"> &nbsp;<span>{{ selectedLogoFormFactors?.manufacturer}}</span></div></div>
              <div id="applyContentGrpProcessorsSection" >
                <div id="applyContentGrpProcessors" class ="font-bold inline-block"><span>{{globConst.PROCESSORS}}</span>: </div>
                <div id="selectedLogoFormFactorsProcessors" class="inline">&nbsp; <span>{{ selectedLogoFormFactors?.processors}} </span></div>
              </div>
              <div id="applyContentGrpGenerationsSection">
                <div id="applyContentGrpGeneration" class ="font-bold inline-block"><span >{{globConst.GENERATIONS}}</span>: </div>
                <div id="selectedLogoFormFactorsGeneration" class="inline">&nbsp;<span>{{ selectedLogoFormFactors?.generations}} </span></div>
              </div>
            </div>
          </div>
        </div>
        <!-- IIT2-4652 story end -->
    </div>
      <!-- TODO-->
      <!-- <div class="form-group col-md-6">
        <label for="publishedTimeStamp">Expiry Date & Time<span class="text-danger">*</span></label>
        <div container="body" [ngbPopover]="dateTimePickereExpiry" placement="top-right" container="body"
          [autoClose]="false" popoverTitle="Expiry Date/Time">
          <input class="form-control" value="{{expiryDateTime}}" formControlName="expiryTimeStamp" id="expiryTimeStamp">
          <em class="date_icon cursor-pointer"></em>
          <div *ngIf="isExpiredDateIncorrect" class="formfield_err_msg"> Expiry should not be less than published date
          </div>
        </div>
        <em class="err_icon"></em>
        <span class="formfield_err_msg"></span>
        <ng-template #dateTimePickereExpiry>
          <iposcen-datetimepicker-popover (currentDateTime)="getExpiryNever($event)"
            (selectedDateTime)="getExpirySelectedTime($event)" popoverTitle="Expiry" buttonText="Expire Never">
          </iposcen-datetimepicker-popover>
        </ng-template>
      </div> -->
      <!-- <div class="form-group col-md-8"> -->
        
      <!-- </div> -->
    <!-- </div> -->
  </form>
  <div id="btnWrapper" class="button-wrapper" style="justify-content: flex-end">
    <button type="button" (click)="cancel()" class="btn btn-outline-primary gtmCancelLogo">
      <span i18n="@@create-logo-content.tab-pane.cancel">Cancel</span>
    </button>
    <button type="button" (click)="onAdd()" class="btn btn-primary gtmSaveLogo"
      [disabled]="logoContentgrpForm?.controls?.publishedName?.value?.trim() === ''">
      <span class="gtmSaveLogo" i18n="@@create-logo-content.tab-pane.save-and-proceed">Save and Proceed</span>
    </button>
  </div>
</div>